/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
  FETCH_OCVIEW,
  FETCH_OCVIEW_SUCCESS,
  FETCH_OCVIEW_FAILURE,
  
} from "./actionTypes";
import fetchStatusTypes from "./../fetchStatusTypes";

const OCVIEW = (
  state = {
    isFetching: false,
    fetchStatus: fetchStatusTypes.UNDEFINED,
    didInvalidate: false,
   
    canOcviewOverview: true,
    canOcviewAlarms: true,
    canOcviewInventory: true,
    canOcviewContainers: true,
    canOcviewReports: true,
    canOcviewDashboards: true,
    canOcviewSLA: true,
    canOcviewSLM: true,
    canOcviewGroups: true,
    unAccessibleList:[],
    },
  action
) => {
  switch (action.type) {
   
    case FETCH_OCVIEW:
      return Object.assign({}, state, {
        isFetching: true,
        fetchStatus: fetchStatusTypes.FETCHING,
        didInvalidate: false,
        ocviewInfo: {},
        unAccessibleList:[],
      });
    case FETCH_OCVIEW_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        fetchStatus: fetchStatusTypes.COMPLETE,
        didInvalidate: false,
        
        canOcviewOverview: !action.ocviewinfo.includes("Home"),
        canOcviewAlarms: !action.ocviewinfo.includes("Alarms"),
        canOcviewInventory: !action.ocviewinfo.includes("Inventory"),
        canOcviewContainers: !action.ocviewinfo.includes("Cloud Native"),
        canOcviewReports: !action.ocviewinfo.includes("Reports"),
        canOcviewDashboards: !action.ocviewinfo.includes("Dashboard"),
        canOcviewSLA: !action.ocviewinfo.includes("SLA"),
        canOcviewSLM: !(action.ocviewinfo.includes("SLA")),
        canOcviewGroups: !(action.ocviewinfo.includes("Groups")),
       // canOcviewGroups: !(action.ocviewinfo.includes("Tree") && action.ocviewinfo.includes("Badge") && action.ocviewinfo.includes("List")),
        /*canOcviewGroupsTree: !action.ocviewinfo.includes("Tree"),
        canOcviewGroupsBadge: !action.ocviewinfo.includes("Badge"),
        canOcviewGroupsList: !action.ocviewinfo.includes("List"),   */
        unAccessibleList:action.ocviewinfo ,    
        
      });
    case FETCH_OCVIEW_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        fetchStatus: fetchStatusTypes.FAIL,
        didInvalidate: true,
        errorMessage: action.errorMessage,
        ocviewinfo: {},
        unAccessibleList:[],
      });          
    default:
      return state;
  }
};
export default OCVIEW;
